<div class="confirm-modal" [ngClass]="'is-' + tone">
  <div class="confirm-modal__header">
    <div class="confirm-modal__badge">
      <span></span>
    </div>

    <div class="confirm-modal__copy">
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
    </div>
  </div>

  <div *ngIf="detail" class="confirm-modal__detail">
    {{ detail }}
  </div>

  <div class="confirm-modal__actions">
    <button type="button" class="confirm-modal__button confirm-modal__button--ghost" (click)="activeModal.dismiss(false)">
      {{ cancelLabel }}
    </button>
    <button type="button" class="confirm-modal__button confirm-modal__button--solid" [ngClass]="'is-' + tone" (click)="activeModal.close(true)">
      {{ confirmLabel }}
    </button>
  </div>
</div>
